import Customer from './customer';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import { Roles } from '../types';
import type Site from './site';

@JsonApiResource({
  type: 'user',
})
export default class User extends BaseEntity {
  firstName: string = '';
  lastName: string = '';
  cellPhone: string = '';
  @JsonApiProperty({ resolver: Number }) role: Roles = Roles.ROLE_CUSTOMER_STANDARD;
  email: string = '';
  isEnabled: boolean = true;

  @JsonApiRelationship('customer') customer = new Customer();
  @JsonApiRelationship('site') assignedSites = new Array<Site>();
  constructor(
    id?: User['id'],
    firstName: User['firstName'] = '',
    lastName: User['lastName'] = '',
    cellPhone: User['cellPhone'] = '',
    email: User['email'] = '',
    isEnabled: User['isEnabled'] = true,
    role: User['role'] = Roles.ROLE_CUSTOMER_STANDARD,
    customer: User['customer'] = new Customer()
  ) {
    super();
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.cellPhone = cellPhone;
    this.email = email;
    this.isEnabled = isEnabled;
    this.role = role;
    this.customer = customer;
  }
}
